<div class="auth-page auth-page--flow">
  <div class="auth-page__grid">
    <app-auth-showcase-aside />

<main class="auth-main auth-main--flow auth-main--dense">
      <div class="auth-main__content">
        <nav class="auth-mobile-nav" [attr.aria-label]="'auth.login.back' | translate">
          <a
            class="auth-back auth-back--icon"
            routerLink="/authentication/login"
            [attr.aria-label]="'auth.login.back' | translate"
          >
            <i-tabler name="chevron-left" class="auth-back__icon flex"></i-tabler>
          </a>
        </nav>

        <a class="auth-brand" [routerLink]="['/authentication']">
          <img
            src="/assets/images/logos/logo.svg"
            class="auth-brand__logo"
            [attr.alt]="'auth.login.logoAlt' | translate"
          />
        </a>

        <div class="auth-panel">
          @if (!submitted) {
            <h1 class="auth-panel__title">{{ 'auth.resetPassword.title' | translate }}</h1>
            <p class="auth-panel__subtitle">{{ 'auth.resetPassword.subtitle' | translate }}</p>

            @if (codeSentHint) {
              <div class="auth-info-banner auth-info-banner--claim" role="status">
                <mat-icon class="auth-info-banner__icon" aria-hidden="true">mark_email_read</mat-icon>
                <p class="auth-info-banner__text">
                  {{
                    'auth.resetPassword.codeSentBanner'
                      | translate: { email: form.value.email || '' }
                  }}
                </p>
              </div>
            }

            <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()" authScrollOnFocus>
              <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
                <mat-label>{{ 'auth.resetPassword.email' | translate }}</mat-label>
                <input
                  matInput
                  type="email"
                  inputmode="email"
                  autocomplete="email"
                  formControlName="email"
                />
                <mat-error>
                  @if (f['email'].hasError('required')) {
                    {{ 'auth.resetPassword.emailRequired' | translate }}
                  } @else if (f['email'].hasError('pattern')) {
                    {{ 'auth.resetPassword.emailInvalid' | translate }}
                  }
                </mat-error>
              </mat-form-field>

              <div class="auth-reset-otp" authScrollOnFocus>
                <p class="auth-reset-otp__label">{{ 'auth.resetPassword.code' | translate }}</p>
                <app-otp-code-input
                  [length]="otpCodeLength"
                  [disabled]="isSubmitting"
                  [invalid]="!!errorMessage"
                  [resetToken]="otpResetToken()"
                  (codeChange)="onCodeChange($event)"
                />
                <div class="auth-reset-otp__resend">
                  @if (otpRetryAfter() > 0) {
                    <p class="auth-reset-otp__wait">
                      {{ otpResendWaitKey() | translate: { wait: otpResendWaitLabel() } }}
                    </p>
                  } @else {
                    <button
                      type="button"
                      class="auth-link"
                      (click)="resendCode()"
                      [disabled]="isSubmitting"
                    >
                      {{ 'auth.resetPassword.resend' | translate }}
                    </button>
                  }
                </div>
              </div>

              <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
                <mat-label>{{ 'auth.resetPassword.password' | translate }}</mat-label>
                <input
                  matInput
                  [type]="hidePassword ? 'password' : 'text'"
                  autocomplete="new-password"
                  formControlName="password"
                />
                @if (passwordIsValid()) {
                  <mat-icon matSuffix class="auth-password-ok" aria-hidden="true">check_circle</mat-icon>
                }
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  [attr.aria-label]="hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'"
                  (click)="hidePassword = !hidePassword"
                >
                  <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <mat-error>
                  @if (f['password'].hasError('required')) {
                    {{ 'auth.resetPassword.passwordRequired' | translate }}
                  }
                </mat-error>
              </mat-form-field>

              @if (showPasswordRules()) {
                <div class="auth-password-rules" aria-live="polite">
                  @for (rule of passwordRules; track rule) {
                    <div class="auth-password-rule" [class.auth-password-rule--valid]="passwordMeets(rule)">
                      <mat-icon aria-hidden="true">{{
                        passwordMeets(rule) ? 'check_circle' : 'radio_button_unchecked'
                      }}</mat-icon>
                      <span>{{ ('auth.register.passwordRule' + rule) | translate }}</span>
                    </div>
                  }
                </div>
              }

              <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
                <mat-label>{{ 'auth.resetPassword.passwordConfirmation' | translate }}</mat-label>
                <input
                  matInput
                  [type]="hideConfirmPassword ? 'password' : 'text'"
                  autocomplete="new-password"
                  formControlName="passwordConfirmation"
                />
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  [attr.aria-label]="hideConfirmPassword ? 'Mostrar contraseña' : 'Ocultar contraseña'"
                  (click)="hideConfirmPassword = !hideConfirmPassword"
                >
                  <mat-icon>{{ hideConfirmPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <mat-error>
                  @if (form.hasError('passwordMismatch') && f['passwordConfirmation'].touched) {
                    {{ 'auth.resetPassword.passwordMismatch' | translate }}
                  } @else if (f['passwordConfirmation'].hasError('required')) {
                    {{ 'auth.resetPassword.passwordConfirmationRequired' | translate }}
                  }
                </mat-error>
              </mat-form-field>

              <button
                mat-flat-button
                color="primary"
                class="auth-btn-primary"
                type="submit"
                [disabled]="isSubmitting"
              >
                @if (isSubmitting) {
                  <mat-spinner diameter="20" aria-hidden="true"></mat-spinner>
                  {{ 'auth.resetPassword.submitting' | translate }}
                } @else {
                  {{ 'auth.resetPassword.submit' | translate }}
                }
              </button>

              @if (errorMessage) {
                <p class="auth-form-error" role="alert">{{ errorMessage }}</p>
              }
            </form>
          } @else {
            <h1 class="auth-panel__title">{{ 'auth.resetPassword.successTitle' | translate }}</h1>
            <p class="auth-panel__subtitle">{{ 'auth.resetPassword.successBody' | translate }}</p>
            <button mat-flat-button color="primary" class="auth-btn-primary" type="button" (click)="goToLogin()">
              {{ 'auth.resetPassword.backToLogin' | translate }}
            </button>
          }
        </div>
      </div>
    </main>
  </div>
</div>
